module.exports = __webpack_public_path__ + "img/biaouyang_bg.e778cf35.png";